import React, { useEffect, useRef, useState } from "react";
import SendMessage from "./SendMessage";
import AgentMessage from "./AgentMessage";
import ChatHeader from "./ChatHeader";
import CustomerMessage from "./CustomerMessage";
// import UploadCustomerDoc from "./UploadCustomerDoc";
import AlertMessage from "./AlertMessage";
import Modal from "./csatMessage";
import RestartChat from "./RestartChat";
import OfflineMessage from "./OfflineMessage";
import CsatDone from "./CsatDone";
import SinglePlanSelection from "./SinglePlanSelection";
import MultiplePlanSelection from "./MultiplePlanSelection";
import PlanComparisionPopup from "./PlanComparisionPopup";
import { MessageType, Roles } from "../constants";
import PlanFeaturesPopup from "./PlanFeaturesPopup";
import Typing from "./TypingLoader";
import RestartChatConfirmation from "./RestartChatConfirmation";
import WebCalling from "./Health/WebCalling";

function listMessageInChat(
  message_from,
  userId,
  consecutive_messages,
  agentName,
  sendMessage,
  sendEvent,
  displayAllOptions,
  GAEvent,
  showPlansComparison,
  productId,
  regenDoc,
  ShowPlanFeatures,
  isService,
  scrollToBottom,
  isHistoryMessgage,
  scrollintoview,
  lastMessage,
  newTermUi,
  roomClosed,
  haveAgentMsg,
  haveTermWaitingMsg,
  setAgentMsgReplied,
  roomId,
  customerName
) {
  if (consecutive_messages.length > 0) {
    if (message_from === Roles.Customer) {
      return (
        <CustomerMessage
          isService={isService}
          productId={productId}
          GAEvent={GAEvent}
          messages={consecutive_messages}
          regenDoc={regenDoc}
          isHistoryMessgage={isHistoryMessgage}
          setAgentMsgReplied={setAgentMsgReplied}
          roomId={roomId}
          newTermUi={newTermUi}
          customerName={customerName}
        />)
    }
    else if (message_from !== Roles.Customer) {
      return (
        <AgentMessage
          isService={isService}
          GAEvent={GAEvent}
          messages={consecutive_messages}
          agentName={agentName}
          sendMessage={sendMessage}
          sendEvent={sendEvent}
          displayAllOptions={displayAllOptions}
          showPlansComparison={showPlansComparison}
          ShowPlanFeatures={ShowPlanFeatures}
          productId={productId}
          regenDoc={regenDoc}
          scrollToBottom={scrollToBottom}
          isHistoryMessgage={isHistoryMessgage}
          scrollintoview={scrollintoview}
          lastMessage={lastMessage}
          newTermUi={newTermUi}
          roomClosed={roomClosed}
          haveAgentMsg={haveAgentMsg}
          haveTermWaitingMsg={haveTermWaitingMsg}
          setAgentMsgReplied={setAgentMsgReplied}
          roomId={roomId}
        ></AgentMessage>
      );
    }
  } else {
    return null;

  }
}

const sortMessages = (messages) => {
  let message_array = Object.values(messages);
  if (message_array.length > 0) {
    // sort messages on the basis of time
    message_array.sort(function (a, b) {
      return a.sentAt < b.sentAt ? -1 : 1;
    });

    // message_array.sort(function (a, b) {
    //   return a.sentAt - b.sentAt;
    // });
  }
  return message_array;
};
function createMessageList({
  message_array,
  userId,
  agentName,
  sendMessage,
  sendEvent,
  welcomeMsg,
  displayAllOptions,
  GAEvent,
  showPlansComparison,
  productId,
  regenDoc,
  ShowPlanFeatures,
  isService,
  scrollToBottom,
  isHistoryMessgage,
  scrollintoview,
  lastMessage,
  newTermUi,
  roomClosed,
  haveAgentMsg,
  haveTermWaitingMsg,
  setAgentMsgReplied,
  roomId,
  customerName
}) {
  let consecutive_messages = [];
  let formattedMessages = [];
  //console.log(welcomeMsg)
  // convert msg json to array
  if (message_array.length > 0) {
    // map messages according to time
    let message_from = message_array[0].role;
    for (let message of message_array) {
      if (message.type === "alert") {
        // if (consecutive_messages.length > 0) {
        formattedMessages.push(
          listMessageInChat(
            message_from,
            userId,
            consecutive_messages,
            agentName,
            sendMessage,
            sendEvent,
            displayAllOptions,
            GAEvent,
            showPlansComparison,
            productId,
            regenDoc,
            ShowPlanFeatures,
            isService,
            scrollToBottom,
            isHistoryMessgage,
            scrollintoview,
            lastMessage,
            newTermUi,
            roomClosed,
            haveAgentMsg,
            haveTermWaitingMsg,
            setAgentMsgReplied,
            roomId,
            customerName
          )
        );
        consecutive_messages = [];
        formattedMessages.push(
          listMessageInChat(
            message_from,
            userId,
            consecutive_messages,
            agentName,
            sendMessage,
            sendEvent,
            displayAllOptions,
            GAEvent,
            showPlansComparison,
            productId,
            regenDoc,
            ShowPlanFeatures,
            isService,
            scrollToBottom,
            isHistoryMessgage,
            scrollintoview,
            lastMessage,
            newTermUi,
            roomClosed,
            haveAgentMsg,
            haveTermWaitingMsg,
            setAgentMsgReplied,
            roomId,
            customerName
          )
        );
        consecutive_messages = [];
        // }
        formattedMessages.push(
          <AlertMessage productId={productId} messages={message}></AlertMessage>
        );
      } else if (message.content) {
        if (message_from === message.role) {
          consecutive_messages.push(message);
        } else {
          formattedMessages.push(
            listMessageInChat(
              message_from,
              userId,
              consecutive_messages,
              agentName,
              sendMessage,
              sendEvent,
              displayAllOptions,
              GAEvent,
              showPlansComparison,
              productId,
              regenDoc,
              ShowPlanFeatures,
              isService,
              scrollToBottom,
              isHistoryMessgage,
              scrollintoview,
              lastMessage,
              newTermUi,
              roomClosed,
              haveAgentMsg,
              haveTermWaitingMsg,
              setAgentMsgReplied,
              roomId,
              customerName
            )
          );
          consecutive_messages = [];
          consecutive_messages.push(message);
          message_from = message.role;
        }
      }
    }

    if (consecutive_messages.length !== 0) {
      formattedMessages.push(
        listMessageInChat(
          message_from,
          userId,
          consecutive_messages,
          agentName,
          sendMessage,
          sendEvent,
          displayAllOptions,
          GAEvent,
          showPlansComparison,
          productId,
          regenDoc,
          ShowPlanFeatures,
          isService,
          scrollToBottom,
          isHistoryMessgage,
          scrollintoview,
          lastMessage,
          newTermUi,
          roomClosed,
          haveAgentMsg,
          haveTermWaitingMsg,
          setAgentMsgReplied,
          roomId,
          customerName
        )
      );
    }
  }
  if (isHistoryMessgage) {
    formattedMessages.push(
      <div className="chatHistoryDivision"></div>
    );
  }
  return formattedMessages;
}

export default function ChatPage({
  isService,
  sendMessage,
  messages,
  userId,
  agentName,
  uploadFile,
  welcomeMsg,
  sendEvent,
  roomClosed,
  csatDone,
  setCsatDone,
  roomId,
  isOffline,
  restartChat,
  closeChat,
  messageCounter,
  offlineMsg,
  displayAllOptions,
  clearRoomData,
  botName,
  GAEvent,
  showPlansComparison,
  closeComparision,
  planComparison,
  productId,
  regenDoc,
  customerFeedback,
  customerQueryResolutionFeedback,
  planFeatures,
  closePlanFeaturePopup,
  ShowPlanFeatures,
  getHistoryMessages,
  oldMessages,
  roomToken,
  serviceAgentFeedback,
  lastHistoryMsg,
  empId,
  showHistory,
  haveExistingChat,
  setHaveExistingChat,
  source,
  isOfflineWorkingHour,
  offWorkingHourMsg,
  askForRating,
  setTabHasFocus,
  loader,
  chatDivRef,
  newTermUi,
  onCallInitialized,
  onCallDisconnect,
  onCallProcessing,
  webCallIdRef,
  webCallingEnable,
  askForRatingTicket,
  ticketRatingDone,
  ticketInactivityClosed,
  showVideoCallButton,
  agentMsgReplied,
  setAgentMsgReplied,
  customerName,
  totalMsgs
}) { 
  const haveAgentMsg = Object.keys(messages).length > 0 && Object.values(messages).find((item) => item.role === Roles.Agent)
  const haveTermWaitingMsg = Object.keys(messages).length > 0 && Object.values(messages).find((item) => {
    if (item.type === MessageType.json) {
      let content = JSON.parse(item.content);
      if (content.type === "postAssignmentTermMsg") {
        return item;
      }
    }
  })
  const messagesEndRef = useRef(null);
  const [messageCount, setMessageCount] = useState(0);
  const [sortedMessages, setSortedMessages] = useState([]);
  const [csatPopupClosed, setCsatPopupClosed] = useState(false);
  const [modelStatus, setModelStatus] = useState(roomClosed);
  const [showPlanComaprison, setPlanComaprison] = useState(false)
  const [showPlanSelection, setPlanSelection] = useState(false)
  const [typing, setTyping] = useState(true)
  const [sortedOldMessages, setSortedOldMessages] = useState([]);
  const [showHistoryMsg, setShowChatHistory] = useState(false)
  const [chatScroll, setChatScroll] = useState(false);
  const [loading, setLoader] = useState(false)
  const [scrollToBottomButtom, setScrollToButtom] = useState(false)
  const [disableInput, setDisableInput] = useState(false)
  const [option, setOption] = useState("");
  const [errorWebCalling, setErrorWebCalling] = useState(null)
  useEffect(() => {
    if (askForRating === false) {
      setCsatDone();
    }
  }, [askForRating])


  let data = { href: window.location.href, params: {} };
  const queryParams = new URLSearchParams(window.location.search);
  for (const [key, value] of queryParams.entries()) {
    data.params[key] = value;
  }
  let mobileClass = (data.params?.m == 1 && Object.keys(messages).length <= 1) ? 'sm' : '';
  useEffect(() => {
    //console.log("Messages changed");
    setMessageCount(Object.keys(messages).length);
    let sortedMessages = sortMessages(messages);
    setSortedMessages(sortedMessages);
  }, [messages]);
  let lastMessage = sortedMessages.length > 0 ? sortedMessages.at(-1) : null;
  const scrollToBottom = () => {
    if (messagesEndRef.current && Object.keys(messages).length > 1) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const scrollintoview=(id)=>{
    const doc = document.getElementById(id)
    // scrollToBottom()
    doc.scrollIntoView()
  }

  useEffect(() => {
    //console.log("Messages changed");
    setMessageCount(Object.keys(oldMessages).length);
    let sortedMessages = sortMessages(oldMessages);
    setSortedOldMessages(sortedMessages);
  }, [oldMessages]);
  const scroll = () => {

  }
  let oldChat = createMessageList({
    message_array: sortedOldMessages,
    userId: userId,
    agentName: agentName,
    sendMessage: sendMessage,
    sendEvent: sendEvent,
    welcomeMsg: welcomeMsg,
    displayAllOptions: displayAllOptions,
    GAEvent: GAEvent,
    showPlansComparison: showPlansComparison,
    productId: productId,
    regenDoc: regenDoc,
    ShowPlanFeatures: ShowPlanFeatures,
    isService: isService,
    scrollToBottom: scroll,
    isHistoryMessgage: true,
    scrollintoview:scrollintoview,
    lastMessage:lastMessage,
    newTermUi:newTermUi,
    roomClosed: roomClosed,
    haveAgentMsg :haveAgentMsg,
    haveTermWaitingMsg: haveTermWaitingMsg,
    setAgentMsgReplied: setAgentMsgReplied,
    roomId: roomId,
    customerName:customerName
  });

  let messageList = createMessageList({
    message_array: sortedMessages,
    userId: userId,
    agentName: agentName,
    sendMessage: sendMessage,
    sendEvent: sendEvent,
    welcomeMsg: welcomeMsg,
    displayAllOptions: displayAllOptions,
    GAEvent: GAEvent,
    showPlansComparison: showPlansComparison,
    productId: productId,
    regenDoc: regenDoc,
    ShowPlanFeatures: ShowPlanFeatures,
    isService: isService,
    scrollToBottom: scrollToBottom,
    scrollintoview:scrollintoview,
    lastMessage:lastMessage,
    newTermUi:newTermUi,
    roomClosed:roomClosed,
    haveAgentMsg: haveAgentMsg,
    haveTermWaitingMsg: haveTermWaitingMsg,
    setAgentMsgReplied:setAgentMsgReplied,
    roomId: roomId,
    customerName:customerName
  });


  //console.log(lastMessage)
  useEffect(() => {
    //console.log(lastMessage)
    if (
      lastMessage &&
      lastMessage.type === "json"
    ) {
      let content = JSON.parse(lastMessage.content)
      //console.log(content.title)
      if (content.title === "Please select a suitable time slot to schedule a callback with us.") {
        setDisableInput(true)
        return
      }
    }
    setDisableInput(false)
  }, [lastMessage])


  // useEffect(() => {
  //   if(roomClosed){
  //     SetShow(true)
  //   }
  // }, [roomClosed])

  useEffect(() => {
    if(lastMessage && isService){

      const doc = document.getElementById(lastMessage?.messageId)
      scrollToBottom()
      // doc.scrollIntoView()
    }
  }, [lastMessage])
  useEffect(() => {
    if (!isService) {
      setTimeout(() => {
        scrollToBottom();
      }, 100)
    }
  }, [lastMessage]);
  useEffect(() => {
    setModelStatus(roomClosed)
    setCsatPopupClosed(false)
  }, [roomClosed])
  const closePopup = () => {
    setCsatPopupClosed(true);
  };

  // const [show, SetShow] = useState(false)
  const showModal = () => {
    setModelStatus(true)
    setCsatPopupClosed(false);

  };
  useEffect(() => {
    if (lastMessage && lastMessage.type.toLowerCase() === 'json') {
      let content = JSON.parse(lastMessage.content);
      if (content.key === "WaitingForAgentConnect") {
        setTyping(false);
        return;
      }
    }
    if (lastMessage && lastMessage.from != userId && lastMessage.type && lastMessage.type.toLowerCase() === "json") {
      let content = JSON.parse(lastMessage.content)
      if (content.type === "plan_multi_selection") {
        setPlanComaprison(true)
        setTyping(false)
        return
      }
      else if (content.type === "plan_selection") {
        setPlanSelection(true)
        setTyping(false)
        return
      }
      else if (content.type === "plan_comparison") {
        showPlansComparison(lastMessage.messageId)
        setTyping(false)

      }
      else if (content.type === "plan_feature") {
        ShowPlanFeatures(lastMessage.messageId)
        setTyping(false)
      }
    }
    else if (lastMessage && lastMessage.from === userId) {
      setTyping(true)
      setPlanSelection(false)
      setPlanComaprison(false)
      return
    }

    setPlanSelection(false)
    setPlanComaprison(false)
   
      setTyping(false)
    if (!lastMessage) {
      setTyping(true)
    }
  }, [lastMessage])

  const handleScroll = (event) => {
    // console.log(event.currentTarget.scrollTop);
    if (event.currentTarget.scrollTop < 10 && !(event.currentTarget.scrollTop + event.currentTarget.clientHeight >= event.currentTarget.scrollHeight - 200)) {
      setChatScroll(true);
    } else {
      setChatScroll(false);
    }
    if (event.currentTarget.scrollTop + event.currentTarget.clientHeight >= event.currentTarget.scrollHeight - 200) {
      setScrollToButtom(false)
    } else {
      setScrollToButtom(true)
    }
  };

  const getChatHistorymsg = async () => {
    setLoader(true)
    let chatDiv = document.getElementById('chat');
    let height = chatDiv.scrollHeight
    chatDiv.classList.add('adding')
    // document.body.style.overflow='hidden'
    // if (showHistoryMsg) {
    await getHistoryMessages(roomToken, sortedOldMessages?.[0]?.sentAt)
    //}
    setShowChatHistory(true);
    setTimeout(() => {
      document.getElementById('chat').scrollTop = document.getElementById('chat').scrollHeight - height;
      chatDiv.classList.remove('adding')
      setLoader(false)
    }, 20)
  }
  useEffect(() => {
    console.log('loader',loader)
    setTyping(loader)
    if (loader){
      scrollToBottom()
    }
  }, [loader])
  useEffect(() => {
    if (errorWebCalling) {
      const timer = setTimeout(() => {
        setErrorWebCalling(null);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [errorWebCalling]);
  return (
    <>
      <div id="container" className={mobileClass}>
        <main>
          {/* Change username //Chatting with  */}
          <ChatHeader showVideoCallButton={showVideoCallButton} empId={empId} isService={isService} productId={productId} GAEvent={GAEvent} agentName={agentName} showModal={showModal} messageCounter={messageCounter} botName={botName} closeChat={closeChat} roomClosed={roomClosed} source={source} sendMessage={sendMessage} setTabHasFocus={setTabHasFocus} mobileClass={mobileClass} newTermUi={newTermUi} ticketRatingDone={ticketRatingDone} clearRoomData={clearRoomData} />
          {isService ?
            <>
              {loading ?
                <div className={`showHistory active load ${isService && oldMessages ? 'active' : null}`}>
                  <div class="stage">
                    <div class="dot-typing"></div>
                    {/* </div> */}
                  </div></div>
                :
                <div className={`showHistory ${chatScroll && isService && !lastHistoryMsg && showHistory ? 'active' : null}`} onClick={() => getChatHistorymsg()}><i /> Load previous conversations</div>

              }
            </>
            : null}

          <ul onScroll={handleScroll} id="chat" ref={chatDivRef} className={`${chatScroll && isService && !lastHistoryMsg && showHistory ? 'showHistoryMsg' : null} ${(modelStatus && !csatPopupClosed && !csatDone) ? "popup-open" : csatDone ? "popup-open" : ""}   ${showVideoCallButton ? "video-call-active" : ""}`}          >

            {showHistoryMsg ? oldChat : null}
            {messageList}
            {agentMsgReplied && (<div className="repliedChatContainer">
              <div className={`replyToMsg ${agentMsgReplied.role != "customer" ? "agent_msg" : ""}`}>
                <div className="replyToMsgContent">
                  {agentMsgReplied.type === MessageType.json ? (
                    (() => {
                      let repliedContent = JSON.parse(agentMsgReplied.content);
                      return repliedContent.type === MessageType.document ? (
                        <span>Document</span>
                      ) :
                        repliedContent.type === 'MsgReply' ?
                          (<span className="replyText">{repliedContent.title}</span>
                          )
                          :
                          repliedContent.type === 'replyToMsg' ?
                            (
                              <span className="replyText">{repliedContent.body}</span>
                            ) :
                            (
                              <span>{repliedContent.display_value}</span>
                            );
                    })()
                  ) : (
                    <span className="replyText">{agentMsgReplied.content}</span>
                  )}
                </div>

                <button
                  className="replyToMsgClose"
                  onClick={() => setAgentMsgReplied(null)}
                >
                  ✕
                </button>
              </div>
            </div>
            )}

            {typing ? <Typing productId={productId} agentName={agentName} isService={isService} loader={loader}/> : null}
            {scrollToBottomButtom ? <div className={`scrollButton`} onClick={() => scrollToBottom()}>  </div> : null}
            <li style={{ height: "0", padding: "0" }} ref={messagesEndRef} />

          </ul>
          {errorWebCalling ? <div className="agent-busy">{errorWebCalling}</div> : <WebCalling agentName={agentName} onCallDisconnect={onCallDisconnect} roomToken={roomToken} onCallProcessing={onCallProcessing} />}

          <footer>
            {isOffline ? null :
              <>
                {roomClosed ?
                  <RestartChat productId={productId} GAEvent={GAEvent} restartChat={restartChat} setModelStatus={setModelStatus} isService={isService}></RestartChat> :
                  <SendMessage
                    botName={botName}
                    productId={productId}
                    GAEvent={GAEvent}
                    disableInput={disableInput}
                    uploadFile={uploadFile}
                    sendMessage={sendMessage}
                    isService={isService}
                    agentName={agentName}
                    lastMessage={lastMessage}
                    isOfflineWorkingHour={isOfflineWorkingHour}
                    offWorkingHourMsg={offWorkingHourMsg}
                    newTermUi={newTermUi}
                    roomToken= {roomToken}
                    setErrorWebCalling ={setErrorWebCalling}
                    onCallInitialized ={onCallInitialized}
                    webCallIdRef={webCallIdRef}
                    webCallingEnable={webCallingEnable}
                    agentMsgReplied={agentMsgReplied}
                    setAgentMsgReplied={setAgentMsgReplied}
                    totalMsgs={totalMsgs}
                  ></SendMessage>
                }
              </>
            }
          </footer>
          {isOffline ? <OfflineMessage productId={productId} GAEvent={GAEvent} offlineMsg={offlineMsg} /> : null}
          {modelStatus && !csatPopupClosed && !csatDone ? <Modal agentName={agentName} empId={empId} serviceAgentFeedback={serviceAgentFeedback} productId={productId} GAEvent={GAEvent} closePopup={closePopup} setCsatDone={setCsatDone} setModelStatus={setModelStatus} customerFeedback={customerFeedback} customerQueryResolutionFeedback={customerQueryResolutionFeedback} closeChat={closeChat} clearRoomData={clearRoomData} isService={isService} restartChat={restartChat} option={option} setOption={setOption} newTermUi={newTermUi} askForRatingTicket={askForRatingTicket} ticketRatingDone={ticketRatingDone} ticketInactivityClosed={ticketInactivityClosed} /> : null}
          {csatDone ? <CsatDone productId={productId} GAEvent={GAEvent} clearRoomData={clearRoomData} roomId={roomId} isService={isService} restartChat={restartChat} lastMessage={lastMessage} askForRating={askForRating} option={option} /> : null}
          {showPlanComaprison && !csatDone && !modelStatus ? <MultiplePlanSelection productId={productId} GAEvent={GAEvent} message={lastMessage} userId={userId} sendMessage={sendMessage} /> : null}
          {showPlanSelection && !csatDone && !modelStatus ? <SinglePlanSelection productId={productId} GAEvent={GAEvent} message={lastMessage} userId={userId} sendMessage={sendMessage} /> : null}
          {planComparison && !csatDone && !modelStatus ? <PlanComparisionPopup productId={productId} message={planComparison} closeComparision={closeComparision} /> : null}
          {planFeatures && !csatDone && !modelStatus ? <PlanFeaturesPopup productId={productId} message={planFeatures} closePlanFeaturePopup={closePlanFeaturePopup} /> : null}
          {haveExistingChat ? <RestartChatConfirmation isService={isService} productId={productId} GAEvent={GAEvent} restartChat={restartChat} setHaveExistingChat={setHaveExistingChat}></RestartChatConfirmation> : null}
        </main>

      </div>

    </>
  );
}
